import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Pages/Shared/Navbar";
import Contact from "./Pages/Home/Contact";
import Home from "./Pages/Home/Home";
import ProjectDetails1 from "./Pages/Home/ProjectDetails1";
import ProjectDetails2 from "./Pages/Home/ProjectDetails2";
import ProjectDetails3 from "./Pages/Home/ProjectDetails3";
import AboutMe from "./Pages/AboutMe.js/AboutMe";
import Blogs from "./Pages/Blogs/Blogs";
import Footer from "./Pages/Shared/Footer";

function App() {
  return (
    <div className="bg-base-200">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="home" element={<Home />}></Route>
        <Route path="contact" element={<Contact />}></Route>
        <Route path="project/1" element={<ProjectDetails1 />}></Route>
        <Route path="project/2" element={<ProjectDetails2 />}></Route>
        <Route path="project/3" element={<ProjectDetails3 />}></Route>
        <Route path="about-me" element={<AboutMe />}></Route>
        <Route path="blogs" element={<Blogs />}></Route>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
